import Vue from 'vue'
import '@/plugins/vuetify'
import App from '@/App.vue'

import router from '@/router'
import store from '@/store/'
import i18n from '@/i18n'
import excel from 'vue-excel-export'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VCalendar from 'v-calendar';
import DaySpanVuetify from 'dayspan-vuetify'

Vue.use(VueFormWizard)
Vue.use(excel)
Vue.config.productionTip = false
Vue.use(VCalendar, {componentPrefix: 'v',  });
Vue.use(DaySpanVuetify)
new Vue({
  router,
  store,
  i18n,
  
  render: h => h(App)
}).$mount('#app')
